export default __webpack_public_path__ + "static/project-klipkutter-f9bcbfc587a6fc4ff31ffda9ed9cdd48.png";